'use client';

import dynamic from 'next/dynamic';

export const LeadCollectionFormStrapi = dynamic(() =>
  import('./LeadCollectionFormStrapi').then((m) => m.LeadCollectionFormStrapi)
);
